module.exports = __webpack_public_path__ + "static/v-tm_-TERMOS-DE-USO-VALE-VPS-Summit-People-at-the-core-20210524_ENG-b6cb4c3cf98a8fe236c0cfdc5d4021a8.pdf";